var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"p-0",attrs:{"href":'tel:' + _vm.number.replace(/\s/g, '')}},[(_vm.showIcon)?_c('i',{staticClass:"fas fa-phone mr-2"}):_vm._e(),_vm._v(" "+_vm._s(_vm.number)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }